import React, { 
  useState, 
  FunctionComponent, 
  SyntheticEvent
} from 'react';
import {
  Routes, 
  Route, 
  useNavigate,
} from 'react-router';
import { PageBanner } from './components/page-banner';
import { NavPanel } from './components/nav-panel';
import { navItems } from './assets/nav-item-list';
import { FlexContainer } from './components/flex-container';
import { Portfolio } from './components/portfolio-content';
import { About } from './components/about-content';
import { Contact } from './components/contact-content';
import { CV } from './components/cv-content';

import {Footer} from './components/footer';


const selected: boolean = true;

const routeMapping = [
  {
    route: '/portfolio/wikihikes',
    cubeFace: 'front',
  },
  {
    route: '/portfolio/photography',
    cubeFace: 'back',
  },
  {
    route: '/portfolio/woodworking',
    cubeFace: 'top',
  },
  {
    route: '/portfolio/immortal-tree',
    cubeFace: 'left',
  },
  {
    route: '/portfolio/ma-college-scorecard',
    cubeFace: 'right',
  },
];

function App() {
  const path: string = window.location.pathname;
  const routeMap = routeMapping.find(obj => obj.route === path);
  let cubeFace;
  if(routeMap){
    cubeFace = routeMap!.cubeFace;
  } 

  const [appState, setAppstate] = useState({activeSide: cubeFace || 'front'});
  const navigate = useNavigate();

  function onNavItemClick(e: SyntheticEvent, path: string): void {
    e.stopPropagation();
    const routeMap = routeMapping.find(obj => obj.route === path);
    let cubeFace;
    if(routeMap){
      cubeFace = routeMap!.cubeFace;
    } 
    setAppstate( {...appState, ...{activeSide: cubeFace || 'front'}})
    navigate(path);
  }

  return (
    <div className="app">
      <PageBanner
        title="matthewroche.io"
        subTitle='web portfolio'
        className='page-banner'
        onNavItemClick={onNavItemClick}
      />
      <FlexContainer
        className='page-content'
        orientation='row'
        vAlign='flex-start'
        hAlign='flex-start'
      >
        <NavPanel 
          navItems={navItems} 
          onNavItemClick={onNavItemClick} 
          footer={<Footer props={{className: 'nav-footer'}}/>}
        />

        <FlexContainer
          className='content-viewer'
          orientation='column'
          vAlign='top'
          hAlign='center'
          style={{position: 'relative', width: '100%', height: '100%'}}
        >
          <Routes>
            <Route 
              path="/portfolio/*" 
              element={<Portfolio activeSide={appState.activeSide}/>}
            >
            </Route>
            <Route path={"/about"} element={<About/>}/>
            <Route path={"/" } element={<About/>}/>
            <Route path={"/contact" } element={<Contact/>}/>
            <Route path={"/cv" } element={<CV/>}/>
          </Routes>
        </FlexContainer>
      </FlexContainer>
      <Footer props={{className: 'page-footer'}}/>
    </div>
  );
}

export default App;
